import { PresentationTemplate } from '../types';

export const MASTER_PRESENTATION_TEMPLATES_STORAGE_KEY = 'klydapp_master_presentation_templates';

export const DEFAULT_MASTER_PRESENTATION_TEMPLATES: PresentationTemplate[] = [];
